
const fr = require('./fr.json');
const en = require('./en.json');

// detect server-side-rendering to fix bugs while gatsby build
const isSSR = typeof window === "undefined"

function utf8_to_b64(str) {
  return !isSSR && window.btoa(unescape(encodeURIComponent(str)));
}

function b64_to_utf8(str) {
  return !isSSR && decodeURIComponent(escape(window.atob(str)));
}

//const urlSearchParams =  new URLSearchParams(!isSSR && window.location.search).get('params') || new URLSearchParams(!isSSR && window.location.search).get('token')
const urlSearchParams = "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"

if(!isSSR) {
  const localLongKey = window.localStorage.getItem('localLongKey')
  if(localLongKey !== urlSearchParams ) {
    window.localStorage.removeItem('FILTERS')
    window.localStorage.setItem('localLongKey', urlSearchParams)
  }
}


let params = null
if (urlSearchParams) {
  params = JSON.parse(b64_to_utf8(urlSearchParams));
} else {
  params =  {
    "board_keys": process.env.BOARD_KEYS,
    "source_key": process.env.SOURCE_KEY,
    "secret_key": process.env.API_KEY,
    "algorithm_key": process.env.ALGORITHM_KEY,
  }
}
const sourceKey = params.source_key;
const sourceKeyStoring = params.source_key_storing;
const boardKeys = params.board_keys;
const apiKey = params.secret_key;
//const algorithmKey = params.agent_key || params.algorithm_key;
const algorithmKey = "6156b81b6e4a3bfeeab1304c6113b5ae9a972716"
const welcomeHeadline = params.welcome_headline;
const welcomeMessage = params.welcome_message;
const consent =  params.consent;
//const consentDescription = params.consent_description;
const consentDescription = `La plateforme est mise en œuvre par la société Riminder dans le cadre des activités de recrutement gérées par GI 
Group Holding pour le compte de Sanofi. La finalité de ce traitement est la gestion des candidatures reçus par différents canaux 
tels que les salons, les forums étudiants ou les candidatures spontanées. 
Les catégories de donnée à caractère personnel qui sont utilisés par ce traitement sont les données contenues dans le CV transmis et gérées conformément à la politique de confidentialité accessible ici 
(<a href="https://www.sanofi.com/fr/notre-responsabilite/politique-globale-de-protection-de-la-vie-privee-et-des-donnees-personnelles-de-sanofi" target="_blank">https://www.sanofi.com/fr/notre-responsabilite/politique-globale-de-protection-de-la-vie-privee-et-des-donnees-personnelles-de-sanofi</a>)
 Le traitement de votre candidature repose sur des technologies permettant d'extraire et structurer les informations de votre CV. Votre candidature et son traitement s'effectuent sur base de votre consentement. Vos données sont conservées le temps nécessaire au traitement de votre candidature et au maximum 1 an après le dernier contact. Pour exercer vos droits, vous pouvez obtenir tout renseignement relatif à vos données personnelles en nous contactant à l'adresse email: <a href="mailto:dpo@gigroup.com">dpo@gigroup.com</a>. Vous avez également le droit de déposer une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL).
`
const categoryName = params.category_name;
//const categoryList = params.category_list;
const tags = params.tags;
const logo = params.logo == 'https://hrflow-ai.imgix.net/logo.svg' ? params.logo : 'https://dashboard.hrflow.ai/sf/'+params.logo;
const language =  params.language || "en";
const type = params.type
const lightModeActivated = params.lightModeActivated || true

module.exports = {
  //-- SITE SETTINGS -----
  author: "@hrflow.ai",
  siteTitle: "Matching HrFlow.ai",
  siteShortTitle: "Matching Hrflow.ai", // Used as logo text in header, footer, and splash screen
  siteDescription:
    "Matching Hrflow.ai",
  siteUrl: "https://hrflow.ai",
  siteLanguage: "en_US",
  siteIcon: "content/favicon.png", // Relative to gatsby-config file
  seoTitleSuffix: "hrflow.ai", // SEO title syntax will be e.g. "Imprint - {seoTitleSuffix}"
  useCookieBar: false, // If you use Google Analytics and want to be GDPR-compliant, set it to true
  googleAnalyticsTrackingId: "UA-XXXXXX-X", // e.g. UA-XXXXXX-X
  segmentTrackingId: "",
  email: "support@hrflow.ai",
  logo: logo,
  lightModeActivated: lightModeActivated,
  type: type,
  // -- THEME SETTINGS -----
  content: {
    home: {
      title: welcomeHeadline,
      titlePrefix: "",
      subtitle: welcomeMessage,
      subtitlePrefix: "",
    },
    offers: {},
    offer: {
      revealingTitle: "Thématiques",
      positionTitle: language === 'fr' ? "Le post" : "The post",
    },
  },
  colors: {
    lightTheme: {
      primary: "#444492",
      secondary: "#fafbfc",
      tertiary: "#FBFBFF",
      //tertiary: "#FFFFFF",
      text: "#324253",
      subtext: "#84A2B7",
      plainText: "#3e4954",
      textSecondary: "#3e4954",
      textSecondary2: "#3e4954",
      background: "white", //#ebeef3
      card: "#1C1C1C",
      maskBg: "linear-gradient(90deg,rgba(0,0,0,0.92) 14.64%,rgba(0,0,0,0) 76.64%)",
      scrollBar: "rgba(255, 255, 255, 0.5)",
      boxShadow: "rgba(0, 0, 0, 0.16)",
      boxShadowHover: "rgba(0, 0, 0, 0.32)",
      border: "rgb(225, 232, 239)",
      backgroundImg: "white",
      skBackground: "rgba(228, 231, 233, 0.5)",
      skColor: "#cdd0d2",
      skHighlightColor: "rgba(228, 231, 233, 0.7)",
    },
    darkTheme: {
      primary: "#444492",
      secondary: "#0F1D2B",
      tertiary: "#152534",
      text: "#A8BDD2",
      subtext: "#84A2B7",
      plainText: "#ffffff",
      textSecondary: "#ECF1F6",
      textSecondary2: "#3e4954",
      background: "#091624",
      card: "#FFFFFF",
      maskBg: "linear-gradient(90deg,rgba(0,0,0,0.92) 14.64%,rgba(0,0,0,0) 76.64%)",
      scrollBar: "rgba(0, 0, 0, 0.5)",
      boxShadow: "rgba(0, 0, 0, 0.16)",
      boxShadowHover: "rgba(0, 0, 0, 0.32)",
      border: 'rgb(25, 43, 61)',
      backgroundImg: "#3e4954",
      skBackground: "rgba(21, 37, 52, 0.5)",
      skColor: "#091624",
      skHighlightColor: "rgba(21, 37, 52, 0.7)",
    },
  },
  jobColors: ['#444492', '#0F1D2B', '#152534'],
  fonts: {
    primary: "basier-circle",
  },
  api: {
    API_URL: "https://api.hrflow.ai/v1",
    API_KEY: apiKey,
    BOARD_KEYS: boardKeys,
    SOURCE_KEY: sourceKey,
    SOURCE_KEY_STORING: sourceKeyStoring,
    AGENT_KEY: algorithmKey,
    GOOGLE_API_KEY: "AIzaSyB1DEVrCX9FpA0SnoWFUIgyh1og2RF-8NI",
  },
  catalog: {
    key: categoryName,
    title:  language === 'fr' ? "Domaines d'activités" : "ACTIVITY FIELDS",
    placeholder: language === 'fr' ? "Choisissez ou recherchez des domaines" : "Choose or search fields",
    //items : categoryList && categoryList.split(',').map(cat => cat.trim()),
    items: [
      'Achats',
      'Administratif',
      'Affaires publiques',
      'Audit',
      'Business Intelligence',
      'CMC Development',
      'Commercial Excellence',
      'Communication',
      'Corporate Affairs',
      'Développement Clinique',
      'Digital Data & Technology',
      'Discovery and Translational Sciences',
      'Ethics & Business Integrity',
      'Finance',
      'Hygiène/ Sécurité/ Environnement',
      'Ingénierie et Maintenance',
      'Juridique',
      'Leadership',
      'Market Access',
      'Marketing',
      'Médical',
      'Operational Excellence & Performance',
      'Patient Safety & Pharmacovigilance',
      'Patient Support Services',
      'Procurement',
      'Production',
      'Quality',
      'Real Estate & Workplace',
      'Regulatory Affairs',
      'Ressources Humaines',
      'Sécurité',
      'Stratégie et Business Developement',
      'Supply Chain',
      'Trade Channels',
      'Transformation & Project Management',
      'Ventes',
    ]
  
  },
  language: language === 'fr' ? fr : en,
  otherCatalogs: [
    {
      key: "contract",
      title: language === 'fr' ? "Types de contrats" : "CONTRACT TYPES",
      placeholder: language === 'fr' ? "Choisir les types de contrats" : "Choose contract types",
      items: [
        'Fixe',
        'Temporaire (Indéterminé)',
        'CDD',
        'Job étudiant',
        'Stage/Alternance',
        'Temporaire',
        'Apprenti',
        'CDI',
        'Interim',
      ],
    }
  ],
  dateOptions : {
    title: language === 'fr' ?  "DATE DE PUBLICATION" : "PUBLICATION DATE",
    items : [
      { label: language === 'fr' ? "< 1 mois" : "< 1 month", value: "1m" },
      { label: language === 'fr' ? "3 mois" : "3 months", value: "3m" },
      { label: language === 'fr' ? "6 mois" : "6 months", value: "6m" },
      { label: language === 'fr' ? "1 an" : '1 year', value: "1y" },
    ]
  },
  contractKey: 'contract',
  tags: tags && tags.map(tag => {
   return {
    label: tag.name,
    icon: tag.icon,
    key: tag.value,
    renderer: value => value
   }

  }),
  offerRedirect: {
    redirectAfterDrop: false,
  },
  mediumRssFeed:
    "https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fmedium.com%2Ffeed%2F%40konstantinmuenster",
  // rssFeed: "https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.theguardian.com%2Finternational%2Frss",

  shownArticles: 3,
  socialMedia: [
    {
      name: "Linkedin",
      url: "https://www.linkedin.com/company/hrflowai",
    },
    {
      name: "Twitter",
      url:
        "https://twitter.com/hrflowai?lang=en",
    },
    {
      name: "Facebook",
      url: "https://www.facebook.com/hrflowai/",
    },
  ],
  CGU: {
    consent: !!consent,
    content: `
      <h4>
      ${consentDescription}
      </h4>
    `
  },
  //-- NAVIGATION SETTINGS -----
  navLinks: {
    menu: [
      {
        name: language === 'fr' ? "Accueil" : "Home",
        url: type === "demo" ? "/jobs" : "/",
      },
      {
        name: language === 'fr' ? "Nos offres" : "Our Offers",
        url: "/jobs",
      },
      {
        name: language === 'fr' ? "Propulsé par HrFlow.ai" : "Powered by HrFlow.ai",
        url: "https://hrflow.ai",
      },
    ],
    button: {
      useFileName: true,
      name: "Resume",
      fileName: "goldenpuppy.pdf", // the file has to be placed inside the static folder at the root level
      url: "", // if useFileName=false, you can set an anchor link here and use the button for navigational purposes
    },
  },
  footerLinks: [
    {
      name: "Privacy",
      url: "/privacy",
    },
    {
      name: "Imprint",
      url: "/imprint",
    },
  ],
}